import React from "react";

export default function FeatureDescription({ Icon, title, description }) {
  return (
    <section className="mx-auto h-full w-full rounded-2xl border border-[#E2E2E2] bg-white p-4 md:p-5 2xl:p-6 shadow-sm hover:shadow-md transition-shadow">
      <article className="flex flex-col items-start">
        <div className="mb-2">{Icon}</div>
        {title}
        {description}
      </article>
    </section>
  );
}
